import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import type { WhatWeTreatProps } from '..';

export const WHAT_WE_TREAT_CONTENT: WhatWeTreatProps = {
  header: 'Our dermatology providers can treat:',
  ctaButton: {
    buttonText: 'Start your skin quiz',
  },
  glyphs: [
    {
      name: 'Acne',
      glyph: <StaticImage src="../images/acne.png" alt="" />,
    },
    {
      name: 'Clogged pores',
      glyph: <StaticImage src="../images/cloggedPores.png" alt="" />,
    },
    {
      name: 'Dark spots',
      glyph: <StaticImage src="../images/darkSpots.png" alt="" />,
    },
    {
      name: 'Fine lines',
      glyph: <StaticImage src="../images/fineLines.png" alt="" />,
    },
    {
      name: 'Firmness',
      glyph: <StaticImage src="../images/firmness.png" alt="" />,
    },
    {
      name: 'Rosacea',
      glyph: <StaticImage src="../images/rosacea.png" alt="" />,
    },
  ],
};
